import React, { forwardRef } from "react";
import accessibleTabs from "../Tabs/AccessibleTabs";
import { getTabs } from "../../utils/functions";

const PerformanceTabs = forwardRef(
  ({ tabs, selectedTab, selectedIndex, handleTab, handleKeyDown }, tabRefs) => {
    return (
      <div className={"tabs port_tabs performance_tab"}>
        <div role="tablist" aria-label="Tabs" className="tab-list">
          {tabs.map((tab, index) => (
            <button
              key={tab.id}
              ref={(el) => (tabRefs.current[index] = el)}
              id={tab.id}
              role="tab"
              aria-selected={selectedIndex === index}
              aria-controls={`panel-${index}`}
              tabIndex={selectedIndex === index ? 0 : -1}
              onClick={() => handleTab({ tab, index })}
              onKeyDown={(e) => handleKeyDown({ e, index, tab })}
              className={`tab-list-item ${
                selectedTab?.id === tab?.id
                  ? "is-active"
                  : "performance-button-animation"
              }`}
            >
              <span className="tab-name">{getTabs(tab?.name)}</span>
            </button>
          ))}
        </div>
      </div>
    );
  },
);

export default accessibleTabs(PerformanceTabs);
